import { busy, notBusy } from '../busy/actions.js'
import {
  handleAddErrors,
  handleGetErrors,
  handleUpdateErrors,
  handleDeleteErrors
} from '../error/actions.js'

import api from '../api.js'
import store from '../store.js'
import storage from '../storage.js'

export const CONTACT_PERSON_CREATE_ACTION = 'CONTACT_PERSON_CREATE_ACTION'
export const CONTACT_PERSON_SHOW_ADD_DIALOG_ACTION = 'CONTACT_PERSON_SHOW_ADD_DIALOG_ACTION'
export const CONTACT_PERSON_HIDE_ADD_DIALOG_ACTION = 'CONTACT_PERSON_HIDE_ADD_DIALOG_ACTION'
export const CONTACT_PERSON_GET_OK_ACTION = 'CONTACT_PERSON_GET_OK_ACTION'
export const CONTACT_PERSON_UPDATE_ACTION = 'CONTACT_PERSON_UPDATE_ACTION'
export const CONTACT_PERSON_SHOW_EDIT_DIALOG_ACTION = 'CONTACT_PERSON_SHOW_EDIT_DIALOG_ACTION'
export const CONTACT_PERSON_HIDE_EDIT_DIALOG_ACTION = 'CONTACT_PERSON_HIDE_EDIT_DIALOG_ACTION'
export const CONTACT_PERSON_DELETE_ACTION = 'CONTACT_PERSON_DELETE_ACTION'
export const CONTACT_PERSON_SHOW_DELETE_DIALOG_ACTION = 'CONTACT_PERSON_SHOW_DELETE_DIALOG_ACTION'
export const CONTACT_PERSON_HIDE_DELETE_DIALOG_ACTION = 'CONTACT_PERSON_HIDE_DELETE_DIALOG_ACTION'

export const CONTACT_PERSON_GET_PAGE_ITEMS_ACTION = 'CONTACT_PERSON_GET_PAGE_ITEMS_ACTION'
export const CONTACT_PERSON_SET_ORDER_ACTION = 'CONTACT_PERSON_SET_ORDER_ACTION'
export const CONTACT_PERSON_SET_LIMIT_ACTION = 'CONTACT_PERSON_SET_LIMIT_ACTION'
export const CONTACT_PERSON_SET_OFFSET_ACTION = 'CONTACT_PERSON_SET_OFFSET_ACTION'
export const CONTACT_PERSON_SET_SEARCH_ACTION = 'CONTACT_PERSON_SET_SEARCH_ACTION'
export const CONTACT_PERSON_RESET_SEARCH_ACTION = 'CONTACT_PERSON_RESET_SEARCH_ACTION'
export const CONTACT_PERSON_SET_FILTER_QUERIES_ACTION = 'CONTACT_PERSON_SET_FILTER_QUERIES_ACTION'

const TAG_FILTER_KEY = 'tags_string'
const OBJECT_TYPE_FILTER_KEY = 'object_type_name_string'
const TAG_FILTER_OP = '~'
const TAG_FILTER_MODE_OR = 'or'
const TAG_FILTER_MODE_AND = 'and'

function filterItemsByTagNames (items, selectedTagNames, matchMode = TAG_FILTER_MODE_OR) {
  if (!Array.isArray(selectedTagNames) || selectedTagNames.length === 0) {
    return items
  }

  const selected = new Set(
    selectedTagNames
      .filter((value) => typeof value === 'string' && value.trim().length > 0)
      .map((value) => value.trim().toLowerCase())
  )

  if (selected.size === 0) {
    return items
  }

  return items.filter((item) => {
    const tagNames = (item?.tags || [])
      .map((tag) => tag?.name)
      .filter((name) => typeof name === 'string' && name.trim().length > 0)
      .map((name) => name.trim().toLowerCase())

    if (matchMode === TAG_FILTER_MODE_AND) {
      return Array.from(selected).every((selectedTag) => tagNames.includes(selectedTag))
    }
    return tagNames.some((name) => selected.has(name))
  })
}

function filterItemsByAnyValues (items, selectedValues, getValue) {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
    return items
  }

  const selected = new Set(
    selectedValues
      .filter((value) => typeof value === 'string' && value.trim().length > 0)
      .map((value) => value.trim().toLowerCase())
  )

  if (selected.size === 0) {
    return items
  }

  return items.filter((item) => {
    const value = getValue(item)
    return typeof value === 'string' && selected.has(value.trim().toLowerCase())
  })
}

export function contactPersonCreateAction (contactPerson) {
  return {
    type: CONTACT_PERSON_CREATE_ACTION,
    contactPerson
  }
}

export function contactPersonUpdateAction (contactPerson) {
  return {
    type: CONTACT_PERSON_UPDATE_ACTION,
    contactPerson
  }
}

export function contactPersonDeleteAction (contactPerson) {
  return {
    type: CONTACT_PERSON_DELETE_ACTION,
    contactPerson
  }
}

/**
 * Add dialog
 */
export function showAddContactPersonDialog () {
  return {
    type: CONTACT_PERSON_SHOW_ADD_DIALOG_ACTION
  }
}

export function hideAddContactPersonDialog () {
  return {
    type: CONTACT_PERSON_HIDE_ADD_DIALOG_ACTION
  }
}

/**
 * Edit dialog
 */
export function showEditContactPersonDialog (contactPerson) {
  return {
    type: CONTACT_PERSON_SHOW_EDIT_DIALOG_ACTION,
    contactPerson
  }
}

export function hideEditContactPersonDialog () {
  return {
    type: CONTACT_PERSON_HIDE_EDIT_DIALOG_ACTION
  }
}

/**
 * Delete dialog
 */
export function showDeleteContactPersonDialog (contactPerson) {
  return {
    type: CONTACT_PERSON_SHOW_DELETE_DIALOG_ACTION,
    contactPerson
  }
}

export function hideDeleteContactPersonDialog () {
  return {
    type: CONTACT_PERSON_HIDE_DELETE_DIALOG_ACTION
  }
}

/**
 * CREATE
 */
export function addContactPerson (contactPerson) {
  return function (dispatch) {
    dispatch(busy())
    api.addContactPerson(contactPerson).then(() => {
      dispatch(notBusy())
    }).catch(handleAddErrors('contactPerson', dispatch))
  }
}

/**
 * READ
 */
// TODO should be replaced by search function later
export function getContactPersons (params = {}) {
  return function (dispatch) {
    dispatch(busy())
    api.getContactPersons(params).then(result => {
      dispatch(notBusy())
      dispatch(receivedContactPersons(result.data.value))
    }).catch(handleGetErrors('contactPerson', dispatch))
  }
}

function receivedContactPersons (items) {
  return {
    type: CONTACT_PERSON_GET_OK_ACTION,
    items
  }
}

/**
 * UPDATE
 */
export function updateContactPerson (contactPerson) {
  return function (dispatch) {
    dispatch(busy())
    api.updateContactPerson(contactPerson).then(() => {
      dispatch(notBusy())
    }).catch(handleUpdateErrors('contactPerson', dispatch))
  }
}

/**
 * DELETE
 */
export function deleteContactPerson (contactPerson) {
  return function (dispatch) {
    dispatch(busy())
    api.deleteContactPerson(contactPerson).then(() => {
      dispatch(notBusy())
      dispatch(getPageItems())
    }).catch(handleDeleteErrors('contactPerson', dispatch))
  }
}

/**
 * Get items for a page
 */
export function getPageItems () {
  const state = store.getState()
  const { search, filterQueries, limit, offset, orderBy, order } = state.contactPerson

  let query = []
  if (typeof search === 'string' && search.length > 0) {
    const split = search.split(',').map(s => s.trim())
    if (split.length === 1) {
      if (split[0].length > 0) query.push({ key: 'name', value: split[0], op: '~' })
    } else if (split.length === 2) {
      if (split[0].length > 0) query.push({ key: 'name', value: split[0], op: '~' })
      if (split[1].length > 0) query.push({ key: 'collection_name', value: split[1], op: '~' })
    }
  }
  const allFilters = Array.isArray(filterQueries) ? filterQueries : []
  const tagFilters = allFilters.filter((q) => q.key === TAG_FILTER_KEY && q.op === TAG_FILTER_OP)
  const objectTypeFilters = allFilters.filter((q) => q.key === OBJECT_TYPE_FILTER_KEY && q.op === TAG_FILTER_OP)
  const nonTagFilters = allFilters.filter((q) => {
    const isTagFilter = q.key === TAG_FILTER_KEY && q.op === TAG_FILTER_OP
    const isObjectTypeFilter = q.key === OBJECT_TYPE_FILTER_KEY && q.op === TAG_FILTER_OP
    return !isTagFilter && !isObjectTypeFilter
  })
  const selectedTagNames = tagFilters.map((q) => q.value)
  const selectedObjectTypeNames = objectTypeFilters.map((q) => q.value)
  const selectedTagMatchMode = tagFilters.find((q) => q.matchMode === TAG_FILTER_MODE_AND)
    ? TAG_FILTER_MODE_AND
    : TAG_FILTER_MODE_OR
  query = [...query, ...nonTagFilters]

  const sort = orderBy ? `${orderBy}.${order}` : null

  const numericLimit = Number(limit)
  const pageLimit = Number.isFinite(numericLimit) && numericLimit > 0 ? numericLimit : 50
  const numericOffset = Number(offset) || 0

  if (selectedTagNames.length > 0 || selectedObjectTypeNames.length > 0) {
    return function (dispatch) {
      dispatch(busy())
      api.getContactPersons({
        query,
        sort,
        limit: Math.max(1000, numericOffset + pageLimit),
        offset: 0
      }).then(result => {
        let filteredItems = result.data.value
        filteredItems = filterItemsByTagNames(filteredItems, selectedTagNames, selectedTagMatchMode)
        filteredItems = filterItemsByAnyValues(filteredItems, selectedObjectTypeNames, (item) => item?.object_type_name)
        const pageItems = filteredItems.slice(numericOffset, numericOffset + pageLimit)
        dispatch(notBusy())
        dispatch({
          type: CONTACT_PERSON_GET_PAGE_ITEMS_ACTION,
          pageItems
        })
      }).catch(handleGetErrors('contactPerson', dispatch))
    }
  }

  return function (dispatch) {
    dispatch(busy())
    api.getContactPersons({
      query,
      limit,
      offset,
      sort
    }).then(result => {
      dispatch(notBusy())
      dispatch({
        type: CONTACT_PERSON_GET_PAGE_ITEMS_ACTION,
        pageItems: result.data.value
      })
    }).catch(handleGetErrors('contactPerson', dispatch))
  }
}

/**
 * Sort order
 */
export function setOrder (orderBy, order) {
  return {
    type: CONTACT_PERSON_SET_ORDER_ACTION,
    orderBy,
    order
  }
}

/**
 * Set limit for pagination
 */
export function setLimit (limit) {
  return {
    type: CONTACT_PERSON_SET_LIMIT_ACTION,
    limit
  }
}

/**
 * Set offset for pagination
 */
export function setOffset (offset) {
  return {
    type: CONTACT_PERSON_SET_OFFSET_ACTION,
    offset
  }
}

/**
 * Set search
 */
export function setSearch (search) {
  return {
    type: CONTACT_PERSON_SET_SEARCH_ACTION,
    search
  }
}

/**
 * Set filter queries
 */
export function setFilterQueries (filterQueries) {
  storage.putPageSetting('contact-person', { filterQueries })
  return {
    type: CONTACT_PERSON_SET_FILTER_QUERIES_ACTION,
    filterQueries
  }
}

/**
 * Reset search
 */
export function resetSearch () {
  return {
    type: CONTACT_PERSON_RESET_SEARCH_ACTION
  }
}
